<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBluetooth_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M17.697 7.717a1 1 0 0 0-.072-1.498L12.63 2.224A.999.999 0 0 0 11 3v6.586L6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414L11 14.414v6.578a1 1 0 0 0 1.63.784l4.983-3.986.054-.045a1 1 0 0 0 .03-1.462l-2.858-2.858L13.414 12zM13 14.414v4.505l2.503-2.002-1.616-1.616zm0-9.333v4.505l2.503-2.503z"
        clip-rule="evenodd"
    />
</svg>
